import React from 'react';
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';

class ClientesReporte extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'contra-recibo/one', saveUrl: 'contra-recibo/save', backUrl: 'jfhdfs' },
      new Form([
        Form.Field('radio', 'reporte', 'Tipo de reporte', '', [Validators.required], 12, [
          { Label: 'Clave, RFC, descripción, teléfono, plazo, dirección, sucursal', Value: 1 },
          { Label: 'Clave, plazo, día revisión, día pago', Value: 2 },
          { Label: 'Todos los datos', Value: 3 },
          { Label: 'Últimos movimientos de clientes', Value: 4 },
        ]),
        Form.Field('radio', 'cliente', 'Tipo de cliente', '1', [Validators.required], 12, [
          { Label: 'Todos', Value: 1 },
          { Label: 'Crédito', Value: 2 },
          { Label: 'Contado', Value: 3 },
        ]),
        Form.Field('select', 'id_sucursal', 'Sucursal', '0', [Validators.required], 12),
      ], ['Reporte'], ''), this.formData
    )

    // this.LoadPreds(this.props.factura.id, false);
  }

  formData = async (form) => {
    let newForm = form;
    let Res = await Http.get('reporte-cobranza/reporte/form');
    console.log(Res);
    if (!Res.error) {
      newForm = Form.FieldOptions(form, 'id_sucursal', [{ id: 0, sucursal_nombre: 'Cualquiera' }, ...Res.data.sucursales], 'id', 'sucursal_nombre');
    }
    return newForm;
  }

  onSubmit = async (button, vals) => {
    // console.log(vals);
    this.setState({ loading: true });
    let params = {
      ...vals,
    }
    try {
      let Res = await Http.get(`cliente-reporte/reporte?${objectAsParams(params)}`, true, 'arraybuffer');
      console.log(Res);

      if (Res) {
        const blob = new Blob([Res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'ReporteClientes.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      // if (!Res.error) {

      // }
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div style={{ backgroundColor: 'white' }}>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(ClientesReporte)
